<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { openExternalLink } from '@/telegramWebApp'

// One removable chip of a `TagInput`.
const { t } = useI18n()
defineProps<{
  value: string
  prefix?: string
  link?: string | null
  disabled?: boolean
}>()
defineEmits<{ remove: [] }>()
</script>

<template>
  <span class="ui-chip tag" :data-value="value">
    <a v-if="link" href="#" @click.prevent="openExternalLink(link)">{{ prefix }}{{ value }}</a>
    <span v-else>{{ prefix }}{{ value }}</span>
    <button
      v-if="!disabled"
      type="button"
      class="remove"
      :aria-label="t('tags.remove', { value })"
      @click="$emit('remove')"
    >
      ✕
    </button>
  </span>
</template>

<style scoped>
.tag {
  font-size: 0.85rem;
  color: var(--tg-text-color);
}

.remove {
  padding: 0;
  border: none;
  background: none;
  color: var(--tg-hint-color);
  cursor: pointer;
  font-size: 0.75rem;
}
</style>
